import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

const LineChart = () => {
  const { getApi } = UseApi();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res: any = await getApi(`admin-actions/users-month-count`);
      setUsers(res?.data?.data);
    };
    fetchData();
  }, []);
  const options = {
    chart: {
      id: 'users-line',
    },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sep',
        'Nov',
        'Dec',
      ],
    },
  };
  const series = [
    {
      name: 'user registrations',
      data: users,
    },
  ];

  return (
    <div>
      <Header extraClasses="my-4">Number of User Registrations</Header>
      {users && (
        <Chart
          options={options}
          series={series}
          type="line"
          className="mx-auto  w-full md:w-5/6  lg:w-3/4"
        />
      )}
    </div>
  );
};

export default LineChart;
